/**
 * @generated SignedSource<<abf1d4b6d37a1507cf9a4d1c42727d68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightSidebar_flight$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "FlightSidebarPackages_flight" | "FlightStatus_flight">;
  readonly " $fragmentType": "FlightSidebar_flight";
};
export type FlightSidebar_flight$key = {
  readonly " $data"?: FlightSidebar_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightSidebar_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightSidebar_flight",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightStatus_flight"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightSidebarPackages_flight"
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "02cd76505eb5b83684e3578ee6e6ac5c";

export default node;
